import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Message, SpinnerService, UtilsService } from 'shared-components';
import { ConfiguracionContextService } from '../../context/configuracion-context.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-mantenimiento-etiquetas',
    templateUrl: './mantenimiento-etiquetas.component.html'
})
export class MantenimientoEtiquetasComponent implements OnInit, OnDestroy {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

    private _filters;
    public filtersVisible = false;
    public filtersForm: UntypedFormGroup;

    public gruposEtiqueta;
    public listado = [];
    public grados = [];
    public textosDenominacion = [];
    public configuraciones = [];
    public tipos = [];
    public versionesNiceLabel = [];

    public grupoEtiquetaId;
    public desGrupoEtiqueta;
    public formatosAsociados;

    public nivelAsignaciones = [];

    public newEditModal = false;
    public deleteModal = false;
    public uploadModal = false;
    public formatosModal = false;

    public mensajes = new Array<Message>();
    public showError: boolean;

    public dropdownInfo: number;

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    public orderBy: string;
    public columnId: number;

    private readonly destroy$ = new Subject<void>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _sessionContext: SessionContextService,
        private readonly _dataProvider: DataProvider,
        private readonly _configuracionContext: ConfiguracionContextService,
        private readonly _configuracionService: ConfiguracionService,
        private readonly utilsService: UtilsService,
        private readonly _translate: TranslateService
    ) { }

    ngOnInit() {
        this.filtersForm = this._fb.group({
            versionNiceLabel: [{ value: '', disabled: true }],
            des: [''],
            nombreFormato: [''],
            cargarAsignaciones: [''],
            configuracion: [''],
            grados: [''],
            textoDenominacion: [''],
            tipoConfeccion: [''],
            asDenominacion: [false],
            asMarca: [false],
            asPaisDenominacion: [false],
            asMarcaPaisDenominacion: [false],
            asEtiquetadorDenominacion: [false],
            asEtiquetadorMarca: [false],
            asLicenciaParametrizacion: [false],
            asLicenciaParametrizacionMarca: [false],
            fechaInicio: [''],
            fechaFin: [''],
            dateType: ['false']
        });

        this._configuracionContext.mantenimientoEtiquetasFilters = null;

        this.filtersForm.get('fechaInicio').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());
        this.filtersForm.get('fechaFin').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());

        this.textosDenominacion.push(
            {
                id: 1,
                des: 'Un texto'
            },
            {
                id: 2,
                des: 'Dos textos'
            },
        );

        this.grados.push(
            {
                id: 0,
                des: 'Horizontal'
            },
            {
                id: 90,
                des: 'Horizontal Rotado'
            },
            {
                id: 180,
                des: 'Vertical'
            },
            {
                id: 270,
                des: 'Vertical Rotado'
            }
        );

        this.configuraciones.push(
            {
                id: 1,
                des: 'Driver'
            },
            {
                id: 2,
                des: 'Etiqueta'
            },
        );

        this.versionesNiceLabel.push(
            {
                id: 1,
                des: 'Grupos de etiquetas NiceLabel 2019'
            }
        );

        this.tipos.push(
            {
                id: 1,
                des: 'Caja'
            },
            {
                id: 2,
                des: 'Pallet'
            }
        );

        this.versionesNiceLabel.push(
            {
                id: 1,
                des: 'Grupos de etiquetas NiceLabel 2019'
            }
        );

        this.filtersForm.get('versionNiceLabel').patchValue(this.versionesNiceLabel.find(x => x.id === 1));

        this.getGruposEtiqueta();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get yesNo() {
        return this._dataProvider.yesNo;
    }

    public get defaultLanguage() {
      return this._translate.getDefaultLang();
    }

    public get isSmallScreen(){
      return this._sessionContext.isSmallScreen();
    }

    public pageChange(page) {
        this.dropdownInfo = -1;
        this._configuracionContext.mantenimientoEtiquetasFilters.numPagina = this.currentPage = page - 1;
        this.getGruposEtiqueta();
    }

    public itemsPerPageChange(items) {
        this.dropdownInfo = -1;
        this._configuracionContext.mantenimientoEtiquetasFilters.numPagina = this.currentPage = 0;
        this._configuracionContext.mantenimientoEtiquetasFilters.tamPagina = this.itemsPerPage = items;
        this.getGruposEtiqueta();
    }

    private clearDatesValidators() {
        if (this.filtersForm.get('fechaFin').errors && this.filtersForm.get('fechaFin').value) {
            this.filtersForm.get('fechaFin').clearValidators();
            this.filtersForm.get('fechaFin').updateValueAndValidity();
        }
        if (this.filtersForm.get('fechaInicio').errors && this.filtersForm.get('fechaInicio').value) {
            this.filtersForm.get('fechaInicio').clearValidators();
            this.filtersForm.get('fechaInicio').updateValueAndValidity();
        }
    }

    public validDates() {
        if (this.filtersForm.get('fechaInicio').value && this.filtersForm.get('fechaFin').value) {
            if (this.checkDates(this.filtersForm.get('fechaInicio').value, this.filtersForm.get('fechaFin').value)) {
                this.clearDatesValidators();
            } else {
                this.filtersForm.get('fechaInicio').setErrors(['Invalid date']);
                this.filtersForm.get('fechaFin').setErrors(['Invalid date']);
            }
            if (this.filtersForm.get('fechaInicio').invalid || this.filtersForm.get('fechaFin').invalid) {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.fecha.error.finAnteriorInicio'});
            } else {
                this.showError = false;
                this.mensajes = [];
            }
        } else {
            this.clearDatesValidators();
            this.showError = false;
            this.mensajes = [];
        }
    }

    private checkDates(inicio, fin) {
        const inicioD = new Date(inicio);
        const finD = new Date(fin);
        return inicioD <= finD;
    }

    public checkValuesForm(): boolean {
        return (this.filtersForm.get('des').value ||
            this.filtersForm.get('nombreFormato').value ||
            this.filtersForm.get('configuracion').value ||
            this.filtersForm.get('cargarAsignaciones').value ||
            this.filtersForm.get('grados').value ||
            this.filtersForm.get('textoDenominacion').value ||
            this.filtersForm.get('tipoConfeccion').value ||
            this.filtersForm.get('asDenominacion').value ||
            this.filtersForm.get('asMarca').value ||
            this.filtersForm.get('asPaisDenominacion').value ||
            this.filtersForm.get('asMarcaPaisDenominacion').value ||
            this.filtersForm.get('asEtiquetadorDenominacion').value ||
            this.filtersForm.get('asEtiquetadorMarca').value ||
            this.filtersForm.get('asLicenciaParametrizacion').value ||
            this.filtersForm.get('fechaInicio').value ||
            this.filtersForm.get('fechaFin').value ||
            this.filtersForm.get('asLicenciaParametrizacionMarca').value) ? true : false;
    }

    public resetForm() {
        this.filtersForm.reset();
        this.filtersForm.get('versionNiceLabel').patchValue(this.versionesNiceLabel.find(x => x.id === 1));
        this.filtersForm.get('dateType').patchValue('false');
    }

    public filtrar() {
        this.validDates();
        
        if (this.filtersForm.valid) {
            this.applyFilters();
        }
    }

    private applyFilters() {
        this.currentPage = 0;
        this._configuracionContext.mantenimientoEtiquetasFilters = {
            des: this.filtersForm.get('des').value ? this.filtersForm.get('des').value : '',
            lsNivelNivelAsignacion: this.nivelAsignaciones,
            cargarAsignaciones: this.filtersForm.get('cargarAsignaciones').value ? this.filtersForm.get('cargarAsignaciones').value.value : false,
            origenConfiguracionEtiquetaId: this.filtersForm.get('configuracion').value ?
                this.filtersForm.get('configuracion').value.id : null,
            orientacionGrados: this.filtersForm.get('grados').value ? this.filtersForm.get('grados').value.id : null,
            numTextosDenominacion: this.filtersForm.get('textoDenominacion').value ?
                this.filtersForm.get('textoDenominacion').value.id : null,
            desFormatoEtiqueta: this.filtersForm.get('nombreFormato').value ? this.filtersForm.get('nombreFormato').value : '',
            includeFileFormatoEtiqueta: false,
            tipoConfeccionId: this.filtersForm.get('tipoConfeccion').value ? this.filtersForm.get('tipoConfeccion').value.id : null,
            versionNiceLabelId: this.filtersForm.get('versionNiceLabel').value ? this.filtersForm.get('versionNiceLabel').value.id : null,
            fechaInicio: this.filtersForm.get('fechaInicio').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaInicio').value) : '',
            fechaFin: this.filtersForm.get('fechaFin').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaFin').value) : '',
            fechaActualizacion: this.filtersForm.get('dateType').value,
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage
        };
        this.getGruposEtiqueta();
    }

    public getGruposEtiqueta() {
        if (this._configuracionContext.mantenimientoEtiquetasFilters) {
            this._filters = this._configuracionContext.mantenimientoEtiquetasFilters;
        } else {
            this.applyFilters();
        }
        this._spinnerService.showSpinner();
        this._configuracionService.getGruposEtiquetas(this._filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.totalItems = resp.paginacionMeta.totalCount;
            this.gruposEtiqueta = resp.lista;
        }, (error) => {
            this.pushMessage('global.error.noResponse');
        });
    }

    public create() {
        this.grupoEtiquetaId = null;
        this.newEditModal = true;
    }

    public update(grupoEtiqueta) {
        this.grupoEtiquetaId = grupoEtiqueta.id;
        this.newEditModal = true;
    }

    public openFormatos(grupoEtiqueta) {
        this.grupoEtiquetaId = grupoEtiqueta.id;
        this.desGrupoEtiqueta = grupoEtiqueta.des;
        this.formatosAsociados = grupoEtiqueta.formatosEtiqueta;
        this.formatosModal = true;
    }

    public askDelete(grupoEtiqueta) {
        this.grupoEtiquetaId = grupoEtiqueta.id;
        this.deleteModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._configuracionService.deleteGrupoEtiqueta(this.grupoEtiquetaId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then(() => {
            this.close();
            this.pushMessage('global.success.itemDeleted');
            this.getGruposEtiqueta();
        });
    }

    public close() {
        this.deleteModal = false;
        this.newEditModal = false;
    }

    public refresh(value) {
        this.newEditModal = false;
        this.uploadModal = false;
        this.formatosModal = false;
        if (value) {
            this.getGruposEtiqueta();
        }
    }

    public pushMessage(mensaje) {
        this.showError = true;
        if (mensaje.includes('error') || mensaje.includes('ApiErrors')) {
            this.mensajes.push({ class: 'error', message: mensaje });
        } else {
            this.mensajes.push({ class: 'success', message: mensaje });
        }
    }

    public addNivelAsignacion(event: any) {
        if (event.target.checked) {
            this.nivelAsignaciones.push(event.target.id);
        } else {
            const index = this.nivelAsignaciones.indexOf(event.target.id);
            if (index > -1) {
                this.nivelAsignaciones.splice(index, 1);
            }
        }
    }

    public showDetails(i: number) {
        this.dropdownInfo = this.dropdownInfo === i ? -1 : i;
        // Desplazamiento a la izquierda para tablet (mismo tamaño máximo que en table.scss)
        if (this.dropdownInfo !== -1 && window.innerWidth <= 1199) {
            // Retardo en caso de que haya otro detalle abierto
            setTimeout(() => {
                document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
            }, 50);
        }
    }

    public separarAsignaciones(asignaciones) {
        let string;
        for ( let asignacion of asignaciones) {
            if (string) {
                string = string + asignacion.toString() + ' | ';
            } else {
                string = asignacion.toString() + ' | ';
            }
        }
        return string.slice(0, -2);

    }

    public getIcon(prop: string) {
      let iconClass = 'fa fa-sort';
      if (this._filters && this._filters.orderItems && this._filters.orderItems[0].orderProperty === prop) {
          iconClass = this._filters.orderItems[0].orderByDescending === true ? 'fa fa-sort-down' : 'fa fa-sort-up';
      }
      return iconClass;
    }

    public toOrderBy(columnFilter, idColumn) {
      this.columnId = idColumn;
      if (this.gruposEtiqueta && this.gruposEtiqueta.length > 0) {
        if (this._configuracionContext.mantenimientoEtiquetasFilters) {
          this._filters = this._configuracionContext.mantenimientoEtiquetasFilters;
          if (!this.orderBy || this.orderBy.includes('DESC')) {
            this.orderBy = 'ASC' + idColumn;
            this._filters.orderItems = [
              {
                orderProperty: columnFilter,
                orderByDescending: false
              }
            ];
          } else if (this.orderBy.includes('ASC')) {
            this.orderBy = 'DESC' + idColumn;
            this._filters.orderItems = [
              {
                orderProperty: columnFilter,
                orderByDescending: true
              }
            ];
          }
          this.getGruposEtiqueta();
        }
      }
    }

    public trackByGrupoEtiquetaId(index: number, grupoEtiqueta: { id: number }): number {
      return grupoEtiqueta.id;
    }
}
